import { AbstractCellField, setCellFieldSymbols } from '../../generated'

export default AbstractCellField

/** @constructor @extends {AbstractCellField} @suppress {checkTypes} */ function _CellField() {}
AbstractCellField.__implement(
 _CellField.prototype = /** @type {!AbstractCellField} */ ({
  projectStartCell(d) {
   const{asICellField:{getCell}}=this
   const cell=getCell(d)
   if(!cell)return
   cell.setState({projectStart:true})
  },
  unprojectStartCell(d) {
   const{asICellField:{getCell}}=this
   const cell=getCell(d)
   if(!cell)return
   cell.setState({projectStart:false})
  },
  projectEndCell(d) {
   const{asICellField:{getCell}}=this
   const cell=getCell(d)
   if(!cell)return
   cell.setState({projectEnd:true})
  },
  unprojectEndCell(d) {
   const{asICellField:{getCell}}=this
   const cell=getCell(d)
   if(!cell)return
   cell.setState({projectEnd:false})
  },
 }),
 _CellField.prototype = /** @type {!ru.hulkmoto.ICellField} */ ({
  initialiser({cells} = {}) {
   setCellFieldSymbols(this, {
    _cells: cells,
   })
   if(cells) {
    const cellMap={}
    setCellFieldSymbols(this, {
     _cellsMap:cellMap,
    })
    for(const cell of cells) {
     const{props:{number:number}}=cell
     cellMap[`${number}`] = cell
    }
   }
   return this
  },
  getCell(d) {
   const{cellsMap:cellsMap}=this
   return cellsMap[`${d}`] || null
  },
  occupyCell(d) {
   const{asICellField:{getCell:getCell}}=this
   const cell=getCell(d)
   cell.setState({occupy:true})
  },
  unoccupyCell(d) {
   const{asICellField:{getCell}}=this
   const cell = getCell(d)
   cell.setState({occupy:false})
  },
  startCell(d) {
   const{asICellField:{getCell}}=this
   const cell = getCell(d)
   cell.setState({start:true})
  },
  unstartCell(d) {
   const{asICellField:{getCell}}=this
   const cell = getCell(d)
   cell.setState({start:false})
  },
  endCell(d) {
   const{asICellField:{getCell}}=this
   const cell = getCell(d)
   cell.setState({end:true})
  },
  unendCell(d) {
   const{asICellField:{getCell}}=this
   const cell = getCell(d)
   cell.setState({end:false})
  },
  projectCell(d) {
   const{asICellField:{getCell}}=this
   const cell=getCell(d)
   if(!cell)return
   cell.setState({project:true})
  },
  unprojectCell(d) {
   const{asICellField:{getCell}}=this
   const cell=getCell(d)
   if(!cell)return
   cell.setState({project:false})
  },
 }),
)